import router from '@/router'
import axios from 'axios'
export default function (url) {
  const list = url.split('.')
  const type = list[list.length - 1]
  //如果是pdf文件
  if (type == 'pdf') {
    // const routeData = router.resolve({
    //   path: '/pdf',
    //   query: {
    //     url
    //   }
    // })
    // window.open(routeData.href, '_blank')
    let blob = new Blob([url], {})

    axios({
      url,
      method: 'GET',
      responseType: 'blob' // 重要
    })
      .then((response) => {
        const blob = new Blob([response.data], {
          type: 'application/pdf;charset=utf-8'
        })
        const href = URL.createObjectURL(blob)
        window.open(href, 'newWindow')
      })
      .catch((error) => {
        console.error('下载文件出错:', error)
      })
    return
  }
  window.open(url)
}



// WEBPACK FOOTER //
// ./src/utils/viewersFile.js